<template src="./selectbox.html"></template>

<script lang="ts">
import fieldGroupPropsMixin from './FieldGroupPropsMixin.vue'
import FieldGroup from './FieldGroup.vue'

export default {
  props: {
    describedbyId: {
      type: String,
      default: () => `tt-hint-${Math.random().toString(16).slice(5)}`
    },
    disabled: Boolean,
    id: {
      type: String,
      default: () => `tt-selectbox-${Math.random().toString(16).slice(5)}`
    },
    modelValue: String,
    name: {
      type: String,
      required: true
    },
    options: { type: Array, required: true },
    selectOneText: String
  },
  emits: ['update:modelValue'],
  mixins: [fieldGroupPropsMixin],
  components: { 'tt-field-group': FieldGroup },
  methods: {
    updateValue(e) {
      this.$emit('update:modelValue', e.target.value)
    }
  }
}
</script>

<style lang="scss" src="./selectbox.scss"></style>
